import { useCheckRoles } from 'hooks';
import { UserRole } from 'interfaces';
import { useEffect } from 'react';
import { useAppDispatch } from 'redux/hooks';
import { getDiscountRequestUnreadNotificationCountThunk } from 'redux/modules/Notifications/notifications.thunk';

const NOTIFICATION_FETCH_INTERVAL = 600_000;

export const NotificationCountFetcher = () => {
  const dispatch = useAppDispatch();
  const isRoleForNotifications = useCheckRoles(
    UserRole.User,
    UserRole.Mod,
    UserRole.Super,
    UserRole.Admin,
  );

  useEffect(() => {
    let intervalCleanup: (() => void) | undefined;

    if (isRoleForNotifications) {
      dispatch(getDiscountRequestUnreadNotificationCountThunk());

      const intervalId = setInterval(() => {
        dispatch(getDiscountRequestUnreadNotificationCountThunk());
      }, NOTIFICATION_FETCH_INTERVAL);

      intervalCleanup = () => clearInterval(intervalId);
    }

    return intervalCleanup;
  }, [isRoleForNotifications]);

  return null;
};
